import { render, staticRenderFns } from "./AddContacts.vue?vue&type=template&id=e2fe4e9c&scoped=true&"
import script from "./AddContacts.vue?vue&type=script&lang=js&"
export * from "./AddContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe4e9c",
  null
  
)

export default component.exports